module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Saturation-d03548c2b81fb85bba59b39667f33bab.svg";